module.exports = __webpack_public_path__ + "static/media/icon_universal.7d333a20.svg";